import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';

import type { Flag } from '#utils/flags/records/Flag';
import { createFlag } from '#utils/flags/records/Flag';
import type { FlagConfiguration } from '#utils/flags/records/FlagConfiguration';
import { createFlagConfiguration } from '#utils/flags/records/FlagConfiguration';

const FlagContext = createContext<{ flag: Flag; flagConfiguration: FlagConfiguration }>({
  flag: createFlag(),
  flagConfiguration: createFlagConfiguration(),
});

export function FlagContextProvider({
  flag,
  flagConfiguration,
  children,
}: {
  flag: Flag;
  flagConfiguration: FlagConfiguration;
  children: ReactNode;
}) {
  const contextValue = useMemo(
    () => ({
      flag,
      flagConfiguration,
    }),
    [flag, flagConfiguration],
  );

  return <FlagContext.Provider value={contextValue}>{children}</FlagContext.Provider>;
}

export function useFlagContext() {
  return useContext(FlagContext);
}
